<template>
  <div class="top-bar">
    <img class="left-decoration" src="@/assets/header/header-brush.png" />
    <div class="right">
      <h1>
        West End Stadium
        <span>Experience</span>
      </h1>
    </div>
    <div class="logo-holder">
      <router-link to="/" class="logo">
        <img src="@/assets/icons/logo.svg" />
      </router-link>
      <SectionNav />
    </div>
    <MobileSectionNav class="mobile-section-nav" />
    <img class="right-decoration" src="@/assets/icons/top-right-decoration.svg" />
  </div>
</template>

<script>
import SectionNav from "@/components/Layout/TopBar/SectionNav";
import MobileSectionNav from "@/components/Layout/TopBar/MobileSectionNav";
export default {
  name: "TopBar",
  components: {
    SectionNav,
    MobileSectionNav
  }
};
</script>

<style lang="scss" scoped>
.left-decoration {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  width: 100%;
  opacity: 0;
  transition: opacity 0.2s;
}
.hide-begin {
  .left-decoration,
  .right {
    opacity: 1;
  }
}
.top-bar {
  position: relative;
  overflow: visible;
  pointer-events: none;
}
.right {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  text-align: right;
  opacity: 0;
  transition: opacity 0.2s;
  h1 {
    position: absolute;
    right: 35px;
    top: 25px;
    color: #fff;
    text-transform: uppercase;
    z-index: 1;
    font-weight: 300;
    span {
      font-weight: bold;
    }
  }
  img {
    height: 120px;
    width: 100%;
    object-fit: cover;
  }
}
.right-decoration {
  position: absolute;
  bottom: -15px;
  left: 50%;
  pointer-events: none;
}
.logo-holder {
  position: absolute;
  top: 25px;
  left: 0;
  height: 150px;
  .logo {
    display: inline-block;
    position: relative;
    pointer-events: all;
    margin-left: 30px;
    height: 100%;
    img {
      height: 100%;
    }
  }
}
@media (min-width: 999px) {
  .mobile-section-nav {
    display: none;
  }
}
@media (max-width: 1000px) {
  .right,
  .decoration,
  .right-decoration {
    display: none;
  }
  .logo-holder {
    height: 60px;
    z-index: 1;
  }
  .section-nav:not(.mobile-section-nav) {
    display: none;
  }
}
</style>